import { ClipboardList, Package, Truck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export const FeatureCrossSection = () => {
  const features = [
    {
      icon: ClipboardList,
      title: 'Menu Planning Automation',
      description: 'Plan weeks in advance and auto-calculate ingredients for every meal.',
    },
    {
      icon: Package,
      title: 'Inventory Sync',
      description: 'Know exactly what\'s in stock before you order - no surprises.',
    },
    {
      icon: Truck,
      title: 'Sysco Ordering Integration',
      description: 'Generate purchase orders directly from your menu plan with one click.',
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-deep-teal via-midnight-green to-deep-teal relative overflow-hidden">
      {/* Background accent elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-40 h-40 bg-copper rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-20 right-20 w-48 h-48 bg-copper/60 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-ivory mb-4">Everything Your Kitchen Needs, All in One Place</h2>
          <p className="text-xl text-ivory/80 max-w-2xl mx-auto">
            The core features that power camp kitchens across the country
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="text-center p-8 rounded-xl bg-ivory/5 backdrop-blur-sm border border-copper/20 hover:border-copper/40 hover:bg-ivory/10 transition-all duration-300 animate-fade-in"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-copper/20 mb-6">
                  <Icon className="h-8 w-8 text-copper" />
                </div>
                <h3 className="text-xl font-bold text-ivory mb-3">{feature.title}</h3>
                <p className="text-ivory/80 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Button 
            asChild 
            size="lg"
            className="bg-copper hover:bg-copper/90 text-deep-teal font-semibold shadow-xl hover:shadow-2xl hover:scale-105 transition-all"
          >
            <Link to="/contact">See CampChef Pro in Action</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
